import {
    useEditController,
    EditContextProvider,
    Form,
    SaveButton,
    useNotify,
    useRedirect,
    useTranslate,
    useRefresh,
} from 'react-admin';

import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button as MUIButton,
} from '@mui/material';

import { useFormContext } from 'react-hook-form';
import { Resources } from '../../resource';
import SearchPlaceholderForm from './SearchPlaceholderForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditSearchPlaceholder = ({ id, onClose }: { id: string | number; onClose: () => void }) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const t = useTranslate();
    const form = useFormContext();
    const refresh = useRefresh();

    const controller = useEditController({
        id,
        resource: Resources.searchPlaceholder,
        mutationMode: 'pessimistic',
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.searchPlaceholder.updateSuccess'), { type: 'success' })
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    default:
                        notify(t('module.searchPlaceholder.unknownErrorUpdate'), { type: 'error' });
                        break;
                }
            },
        },
    });

    if (controller.isLoading || !controller.record) return null;

    return (
        <EditContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t('module.searchPlaceholder.edit')}</DialogTitle>
                <DialogContent>
                    <SearchPlaceholderForm isCreate={false} />
                </DialogContent>
                <DialogActions>
                    <MUIButton
                        variant="outlined"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="search-placeholders" action="update">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </EditContextProvider>
    );
};

export default EditSearchPlaceholder;
